/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WorkerRouteImport } from './routes/worker'
import { Route as PendingRouteImport } from './routes/pending'
import { Route as ForbiddenRouteImport } from './routes/forbidden'
import { Route as ClientRouteImport } from './routes/client'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WorkerIndexRouteImport } from './routes/worker.index'
import { Route as ClientIndexRouteImport } from './routes/client.index'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as WorkerTimesheetsRouteImport } from './routes/worker.timesheets'
import { Route as WorkerProfileRouteImport } from './routes/worker.profile'
import { Route as WorkerOnboardingRouteImport } from './routes/worker.onboarding'
import { Route as WorkerAssignmentsRouteImport } from './routes/worker.assignments'
import { Route as WorkerAbsencesRouteImport } from './routes/worker.absences'
import { Route as ClientTimesheetsRouteImport } from './routes/client.timesheets'
import { Route as ClientProfileRouteImport } from './routes/client.profile'
import { Route as ClientOnboardingRouteImport } from './routes/client.onboarding'
import { Route as ClientAssignmentsRouteImport } from './routes/client.assignments'
import { Route as AdminWorkersRouteImport } from './routes/admin.workers'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as AdminTimesheetsRouteImport } from './routes/admin.timesheets'
import { Route as AdminSurchargeRuleSetsRouteImport } from './routes/admin.surcharge-rule-sets'
import { Route as AdminSettingsRouteImport } from './routes/admin.settings'
import { Route as AdminPayrollExportRouteImport } from './routes/admin.payroll-export'
import { Route as AdminDeadlinesRouteImport } from './routes/admin.deadlines'
import { Route as AdminComplianceRouteImport } from './routes/admin.compliance'
import { Route as AdminClientsRouteImport } from './routes/admin.clients'
import { Route as AdminAuditRouteImport } from './routes/admin.audit'
import { Route as AdminAssignmentsRouteImport } from './routes/admin.assignments'
import { Route as AdminAbsencesRouteImport } from './routes/admin.absences'
import { Route as AdminWorkersIndexRouteImport } from './routes/admin.workers.index'
import { Route as AdminClientsIndexRouteImport } from './routes/admin.clients.index'
import { Route as AdminAssignmentsIndexRouteImport } from './routes/admin.assignments.index'
import { Route as AdminWorkersIdRouteImport } from './routes/admin.workers.$id'
import { Route as AdminClientsIdRouteImport } from './routes/admin.clients.$id'
import { Route as AdminAssignmentsIdRouteImport } from './routes/admin.assignments.$id'

const WorkerRoute = WorkerRouteImport.update({
  id: '/worker',
  path: '/worker',
  getParentRoute: () => rootRouteImport,
} as any)
const PendingRoute = PendingRouteImport.update({
  id: '/pending',
  path: '/pending',
  getParentRoute: () => rootRouteImport,
} as any)
const ForbiddenRoute = ForbiddenRouteImport.update({
  id: '/forbidden',
  path: '/forbidden',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientRoute = ClientRouteImport.update({
  id: '/client',
  path: '/client',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkerIndexRoute = WorkerIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WorkerRoute,
} as any)
const ClientIndexRoute = ClientIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ClientRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const WorkerTimesheetsRoute = WorkerTimesheetsRouteImport.update({
  id: '/timesheets',
  path: '/timesheets',
  getParentRoute: () => WorkerRoute,
} as any)
const WorkerProfileRoute = WorkerProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => WorkerRoute,
} as any)
const WorkerOnboardingRoute = WorkerOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => WorkerRoute,
} as any)
const WorkerAssignmentsRoute = WorkerAssignmentsRouteImport.update({
  id: '/assignments',
  path: '/assignments',
  getParentRoute: () => WorkerRoute,
} as any)
const WorkerAbsencesRoute = WorkerAbsencesRouteImport.update({
  id: '/absences',
  path: '/absences',
  getParentRoute: () => WorkerRoute,
} as any)
const ClientTimesheetsRoute = ClientTimesheetsRouteImport.update({
  id: '/timesheets',
  path: '/timesheets',
  getParentRoute: () => ClientRoute,
} as any)
const ClientProfileRoute = ClientProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => ClientRoute,
} as any)
const ClientOnboardingRoute = ClientOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => ClientRoute,
} as any)
const ClientAssignmentsRoute = ClientAssignmentsRouteImport.update({
  id: '/assignments',
  path: '/assignments',
  getParentRoute: () => ClientRoute,
} as any)
const AdminWorkersRoute = AdminWorkersRouteImport.update({
  id: '/workers',
  path: '/workers',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any)
const AdminTimesheetsRoute = AdminTimesheetsRouteImport.update({
  id: '/timesheets',
  path: '/timesheets',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSurchargeRuleSetsRoute = AdminSurchargeRuleSetsRouteImport.update({
  id: '/surcharge-rule-sets',
  path: '/surcharge-rule-sets',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPayrollExportRoute = AdminPayrollExportRouteImport.update({
  id: '/payroll-export',
  path: '/payroll-export',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDeadlinesRoute = AdminDeadlinesRouteImport.update({
  id: '/deadlines',
  path: '/deadlines',
  getParentRoute: () => AdminRoute,
} as any)
const AdminComplianceRoute = AdminComplianceRouteImport.update({
  id: '/compliance',
  path: '/compliance',
  getParentRoute: () => AdminRoute,
} as any)
const AdminClientsRoute = AdminClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAuditRoute = AdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAssignmentsRoute = AdminAssignmentsRouteImport.update({
  id: '/assignments',
  path: '/assignments',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAbsencesRoute = AdminAbsencesRouteImport.update({
  id: '/absences',
  path: '/absences',
  getParentRoute: () => AdminRoute,
} as any)
const AdminWorkersIndexRoute = AdminWorkersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminWorkersRoute,
} as any)
const AdminClientsIndexRoute = AdminClientsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminClientsRoute,
} as any)
const AdminAssignmentsIndexRoute = AdminAssignmentsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminAssignmentsRoute,
} as any)
const AdminWorkersIdRoute = AdminWorkersIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminWorkersRoute,
} as any)
const AdminClientsIdRoute = AdminClientsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminClientsRoute,
} as any)
const AdminAssignmentsIdRoute = AdminAssignmentsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminAssignmentsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/client': typeof ClientRouteWithChildren
  '/forbidden': typeof ForbiddenRoute
  '/pending': typeof PendingRoute
  '/worker': typeof WorkerRouteWithChildren
  '/admin/absences': typeof AdminAbsencesRoute
  '/admin/assignments': typeof AdminAssignmentsRouteWithChildren
  '/admin/audit': typeof AdminAuditRoute
  '/admin/clients': typeof AdminClientsRouteWithChildren
  '/admin/compliance': typeof AdminComplianceRoute
  '/admin/deadlines': typeof AdminDeadlinesRoute
  '/admin/payroll-export': typeof AdminPayrollExportRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/surcharge-rule-sets': typeof AdminSurchargeRuleSetsRoute
  '/admin/timesheets': typeof AdminTimesheetsRoute
  '/admin/users': typeof AdminUsersRoute
  '/admin/workers': typeof AdminWorkersRouteWithChildren
  '/client/assignments': typeof ClientAssignmentsRoute
  '/client/onboarding': typeof ClientOnboardingRoute
  '/client/profile': typeof ClientProfileRoute
  '/client/timesheets': typeof ClientTimesheetsRoute
  '/worker/absences': typeof WorkerAbsencesRoute
  '/worker/assignments': typeof WorkerAssignmentsRoute
  '/worker/onboarding': typeof WorkerOnboardingRoute
  '/worker/profile': typeof WorkerProfileRoute
  '/worker/timesheets': typeof WorkerTimesheetsRoute
  '/admin/': typeof AdminIndexRoute
  '/client/': typeof ClientIndexRoute
  '/worker/': typeof WorkerIndexRoute
  '/admin/assignments/$id': typeof AdminAssignmentsIdRoute
  '/admin/clients/$id': typeof AdminClientsIdRoute
  '/admin/workers/$id': typeof AdminWorkersIdRoute
  '/admin/assignments/': typeof AdminAssignmentsIndexRoute
  '/admin/clients/': typeof AdminClientsIndexRoute
  '/admin/workers/': typeof AdminWorkersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forbidden': typeof ForbiddenRoute
  '/pending': typeof PendingRoute
  '/admin/absences': typeof AdminAbsencesRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/compliance': typeof AdminComplianceRoute
  '/admin/deadlines': typeof AdminDeadlinesRoute
  '/admin/payroll-export': typeof AdminPayrollExportRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/surcharge-rule-sets': typeof AdminSurchargeRuleSetsRoute
  '/admin/timesheets': typeof AdminTimesheetsRoute
  '/admin/users': typeof AdminUsersRoute
  '/client/assignments': typeof ClientAssignmentsRoute
  '/client/onboarding': typeof ClientOnboardingRoute
  '/client/profile': typeof ClientProfileRoute
  '/client/timesheets': typeof ClientTimesheetsRoute
  '/worker/absences': typeof WorkerAbsencesRoute
  '/worker/assignments': typeof WorkerAssignmentsRoute
  '/worker/onboarding': typeof WorkerOnboardingRoute
  '/worker/profile': typeof WorkerProfileRoute
  '/worker/timesheets': typeof WorkerTimesheetsRoute
  '/admin': typeof AdminIndexRoute
  '/client': typeof ClientIndexRoute
  '/worker': typeof WorkerIndexRoute
  '/admin/assignments/$id': typeof AdminAssignmentsIdRoute
  '/admin/clients/$id': typeof AdminClientsIdRoute
  '/admin/workers/$id': typeof AdminWorkersIdRoute
  '/admin/assignments': typeof AdminAssignmentsIndexRoute
  '/admin/clients': typeof AdminClientsIndexRoute
  '/admin/workers': typeof AdminWorkersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/client': typeof ClientRouteWithChildren
  '/forbidden': typeof ForbiddenRoute
  '/pending': typeof PendingRoute
  '/worker': typeof WorkerRouteWithChildren
  '/admin/absences': typeof AdminAbsencesRoute
  '/admin/assignments': typeof AdminAssignmentsRouteWithChildren
  '/admin/audit': typeof AdminAuditRoute
  '/admin/clients': typeof AdminClientsRouteWithChildren
  '/admin/compliance': typeof AdminComplianceRoute
  '/admin/deadlines': typeof AdminDeadlinesRoute
  '/admin/payroll-export': typeof AdminPayrollExportRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/surcharge-rule-sets': typeof AdminSurchargeRuleSetsRoute
  '/admin/timesheets': typeof AdminTimesheetsRoute
  '/admin/users': typeof AdminUsersRoute
  '/admin/workers': typeof AdminWorkersRouteWithChildren
  '/client/assignments': typeof ClientAssignmentsRoute
  '/client/onboarding': typeof ClientOnboardingRoute
  '/client/profile': typeof ClientProfileRoute
  '/client/timesheets': typeof ClientTimesheetsRoute
  '/worker/absences': typeof WorkerAbsencesRoute
  '/worker/assignments': typeof WorkerAssignmentsRoute
  '/worker/onboarding': typeof WorkerOnboardingRoute
  '/worker/profile': typeof WorkerProfileRoute
  '/worker/timesheets': typeof WorkerTimesheetsRoute
  '/admin/': typeof AdminIndexRoute
  '/client/': typeof ClientIndexRoute
  '/worker/': typeof WorkerIndexRoute
  '/admin/assignments/$id': typeof AdminAssignmentsIdRoute
  '/admin/clients/$id': typeof AdminClientsIdRoute
  '/admin/workers/$id': typeof AdminWorkersIdRoute
  '/admin/assignments/': typeof AdminAssignmentsIndexRoute
  '/admin/clients/': typeof AdminClientsIndexRoute
  '/admin/workers/': typeof AdminWorkersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/client'
    | '/forbidden'
    | '/pending'
    | '/worker'
    | '/admin/absences'
    | '/admin/assignments'
    | '/admin/audit'
    | '/admin/clients'
    | '/admin/compliance'
    | '/admin/deadlines'
    | '/admin/payroll-export'
    | '/admin/settings'
    | '/admin/surcharge-rule-sets'
    | '/admin/timesheets'
    | '/admin/users'
    | '/admin/workers'
    | '/client/assignments'
    | '/client/onboarding'
    | '/client/profile'
    | '/client/timesheets'
    | '/worker/absences'
    | '/worker/assignments'
    | '/worker/onboarding'
    | '/worker/profile'
    | '/worker/timesheets'
    | '/admin/'
    | '/client/'
    | '/worker/'
    | '/admin/assignments/$id'
    | '/admin/clients/$id'
    | '/admin/workers/$id'
    | '/admin/assignments/'
    | '/admin/clients/'
    | '/admin/workers/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forbidden'
    | '/pending'
    | '/admin/absences'
    | '/admin/audit'
    | '/admin/compliance'
    | '/admin/deadlines'
    | '/admin/payroll-export'
    | '/admin/settings'
    | '/admin/surcharge-rule-sets'
    | '/admin/timesheets'
    | '/admin/users'
    | '/client/assignments'
    | '/client/onboarding'
    | '/client/profile'
    | '/client/timesheets'
    | '/worker/absences'
    | '/worker/assignments'
    | '/worker/onboarding'
    | '/worker/profile'
    | '/worker/timesheets'
    | '/admin'
    | '/client'
    | '/worker'
    | '/admin/assignments/$id'
    | '/admin/clients/$id'
    | '/admin/workers/$id'
    | '/admin/assignments'
    | '/admin/clients'
    | '/admin/workers'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/client'
    | '/forbidden'
    | '/pending'
    | '/worker'
    | '/admin/absences'
    | '/admin/assignments'
    | '/admin/audit'
    | '/admin/clients'
    | '/admin/compliance'
    | '/admin/deadlines'
    | '/admin/payroll-export'
    | '/admin/settings'
    | '/admin/surcharge-rule-sets'
    | '/admin/timesheets'
    | '/admin/users'
    | '/admin/workers'
    | '/client/assignments'
    | '/client/onboarding'
    | '/client/profile'
    | '/client/timesheets'
    | '/worker/absences'
    | '/worker/assignments'
    | '/worker/onboarding'
    | '/worker/profile'
    | '/worker/timesheets'
    | '/admin/'
    | '/client/'
    | '/worker/'
    | '/admin/assignments/$id'
    | '/admin/clients/$id'
    | '/admin/workers/$id'
    | '/admin/assignments/'
    | '/admin/clients/'
    | '/admin/workers/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  ClientRoute: typeof ClientRouteWithChildren
  ForbiddenRoute: typeof ForbiddenRoute
  PendingRoute: typeof PendingRoute
  WorkerRoute: typeof WorkerRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/worker': {
      id: '/worker'
      path: '/worker'
      fullPath: '/worker'
      preLoaderRoute: typeof WorkerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pending': {
      id: '/pending'
      path: '/pending'
      fullPath: '/pending'
      preLoaderRoute: typeof PendingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forbidden': {
      id: '/forbidden'
      path: '/forbidden'
      fullPath: '/forbidden'
      preLoaderRoute: typeof ForbiddenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/client': {
      id: '/client'
      path: '/client'
      fullPath: '/client'
      preLoaderRoute: typeof ClientRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/worker/': {
      id: '/worker/'
      path: '/'
      fullPath: '/worker/'
      preLoaderRoute: typeof WorkerIndexRouteImport
      parentRoute: typeof WorkerRoute
    }
    '/client/': {
      id: '/client/'
      path: '/'
      fullPath: '/client/'
      preLoaderRoute: typeof ClientIndexRouteImport
      parentRoute: typeof ClientRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/worker/timesheets': {
      id: '/worker/timesheets'
      path: '/timesheets'
      fullPath: '/worker/timesheets'
      preLoaderRoute: typeof WorkerTimesheetsRouteImport
      parentRoute: typeof WorkerRoute
    }
    '/worker/profile': {
      id: '/worker/profile'
      path: '/profile'
      fullPath: '/worker/profile'
      preLoaderRoute: typeof WorkerProfileRouteImport
      parentRoute: typeof WorkerRoute
    }
    '/worker/onboarding': {
      id: '/worker/onboarding'
      path: '/onboarding'
      fullPath: '/worker/onboarding'
      preLoaderRoute: typeof WorkerOnboardingRouteImport
      parentRoute: typeof WorkerRoute
    }
    '/worker/assignments': {
      id: '/worker/assignments'
      path: '/assignments'
      fullPath: '/worker/assignments'
      preLoaderRoute: typeof WorkerAssignmentsRouteImport
      parentRoute: typeof WorkerRoute
    }
    '/worker/absences': {
      id: '/worker/absences'
      path: '/absences'
      fullPath: '/worker/absences'
      preLoaderRoute: typeof WorkerAbsencesRouteImport
      parentRoute: typeof WorkerRoute
    }
    '/client/timesheets': {
      id: '/client/timesheets'
      path: '/timesheets'
      fullPath: '/client/timesheets'
      preLoaderRoute: typeof ClientTimesheetsRouteImport
      parentRoute: typeof ClientRoute
    }
    '/client/profile': {
      id: '/client/profile'
      path: '/profile'
      fullPath: '/client/profile'
      preLoaderRoute: typeof ClientProfileRouteImport
      parentRoute: typeof ClientRoute
    }
    '/client/onboarding': {
      id: '/client/onboarding'
      path: '/onboarding'
      fullPath: '/client/onboarding'
      preLoaderRoute: typeof ClientOnboardingRouteImport
      parentRoute: typeof ClientRoute
    }
    '/client/assignments': {
      id: '/client/assignments'
      path: '/assignments'
      fullPath: '/client/assignments'
      preLoaderRoute: typeof ClientAssignmentsRouteImport
      parentRoute: typeof ClientRoute
    }
    '/admin/workers': {
      id: '/admin/workers'
      path: '/workers'
      fullPath: '/admin/workers'
      preLoaderRoute: typeof AdminWorkersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/timesheets': {
      id: '/admin/timesheets'
      path: '/timesheets'
      fullPath: '/admin/timesheets'
      preLoaderRoute: typeof AdminTimesheetsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/surcharge-rule-sets': {
      id: '/admin/surcharge-rule-sets'
      path: '/surcharge-rule-sets'
      fullPath: '/admin/surcharge-rule-sets'
      preLoaderRoute: typeof AdminSurchargeRuleSetsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/settings': {
      id: '/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/payroll-export': {
      id: '/admin/payroll-export'
      path: '/payroll-export'
      fullPath: '/admin/payroll-export'
      preLoaderRoute: typeof AdminPayrollExportRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/deadlines': {
      id: '/admin/deadlines'
      path: '/deadlines'
      fullPath: '/admin/deadlines'
      preLoaderRoute: typeof AdminDeadlinesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/compliance': {
      id: '/admin/compliance'
      path: '/compliance'
      fullPath: '/admin/compliance'
      preLoaderRoute: typeof AdminComplianceRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/clients': {
      id: '/admin/clients'
      path: '/clients'
      fullPath: '/admin/clients'
      preLoaderRoute: typeof AdminClientsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/audit': {
      id: '/admin/audit'
      path: '/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AdminAuditRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/assignments': {
      id: '/admin/assignments'
      path: '/assignments'
      fullPath: '/admin/assignments'
      preLoaderRoute: typeof AdminAssignmentsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/absences': {
      id: '/admin/absences'
      path: '/absences'
      fullPath: '/admin/absences'
      preLoaderRoute: typeof AdminAbsencesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/workers/': {
      id: '/admin/workers/'
      path: '/'
      fullPath: '/admin/workers/'
      preLoaderRoute: typeof AdminWorkersIndexRouteImport
      parentRoute: typeof AdminWorkersRoute
    }
    '/admin/clients/': {
      id: '/admin/clients/'
      path: '/'
      fullPath: '/admin/clients/'
      preLoaderRoute: typeof AdminClientsIndexRouteImport
      parentRoute: typeof AdminClientsRoute
    }
    '/admin/assignments/': {
      id: '/admin/assignments/'
      path: '/'
      fullPath: '/admin/assignments/'
      preLoaderRoute: typeof AdminAssignmentsIndexRouteImport
      parentRoute: typeof AdminAssignmentsRoute
    }
    '/admin/workers/$id': {
      id: '/admin/workers/$id'
      path: '/$id'
      fullPath: '/admin/workers/$id'
      preLoaderRoute: typeof AdminWorkersIdRouteImport
      parentRoute: typeof AdminWorkersRoute
    }
    '/admin/clients/$id': {
      id: '/admin/clients/$id'
      path: '/$id'
      fullPath: '/admin/clients/$id'
      preLoaderRoute: typeof AdminClientsIdRouteImport
      parentRoute: typeof AdminClientsRoute
    }
    '/admin/assignments/$id': {
      id: '/admin/assignments/$id'
      path: '/$id'
      fullPath: '/admin/assignments/$id'
      preLoaderRoute: typeof AdminAssignmentsIdRouteImport
      parentRoute: typeof AdminAssignmentsRoute
    }
  }
}

interface AdminAssignmentsRouteChildren {
  AdminAssignmentsIdRoute: typeof AdminAssignmentsIdRoute
  AdminAssignmentsIndexRoute: typeof AdminAssignmentsIndexRoute
}

const AdminAssignmentsRouteChildren: AdminAssignmentsRouteChildren = {
  AdminAssignmentsIdRoute: AdminAssignmentsIdRoute,
  AdminAssignmentsIndexRoute: AdminAssignmentsIndexRoute,
}

const AdminAssignmentsRouteWithChildren =
  AdminAssignmentsRoute._addFileChildren(AdminAssignmentsRouteChildren)

interface AdminClientsRouteChildren {
  AdminClientsIdRoute: typeof AdminClientsIdRoute
  AdminClientsIndexRoute: typeof AdminClientsIndexRoute
}

const AdminClientsRouteChildren: AdminClientsRouteChildren = {
  AdminClientsIdRoute: AdminClientsIdRoute,
  AdminClientsIndexRoute: AdminClientsIndexRoute,
}

const AdminClientsRouteWithChildren = AdminClientsRoute._addFileChildren(
  AdminClientsRouteChildren,
)

interface AdminWorkersRouteChildren {
  AdminWorkersIdRoute: typeof AdminWorkersIdRoute
  AdminWorkersIndexRoute: typeof AdminWorkersIndexRoute
}

const AdminWorkersRouteChildren: AdminWorkersRouteChildren = {
  AdminWorkersIdRoute: AdminWorkersIdRoute,
  AdminWorkersIndexRoute: AdminWorkersIndexRoute,
}

const AdminWorkersRouteWithChildren = AdminWorkersRoute._addFileChildren(
  AdminWorkersRouteChildren,
)

interface AdminRouteChildren {
  AdminAbsencesRoute: typeof AdminAbsencesRoute
  AdminAssignmentsRoute: typeof AdminAssignmentsRouteWithChildren
  AdminAuditRoute: typeof AdminAuditRoute
  AdminClientsRoute: typeof AdminClientsRouteWithChildren
  AdminComplianceRoute: typeof AdminComplianceRoute
  AdminDeadlinesRoute: typeof AdminDeadlinesRoute
  AdminPayrollExportRoute: typeof AdminPayrollExportRoute
  AdminSettingsRoute: typeof AdminSettingsRoute
  AdminSurchargeRuleSetsRoute: typeof AdminSurchargeRuleSetsRoute
  AdminTimesheetsRoute: typeof AdminTimesheetsRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminWorkersRoute: typeof AdminWorkersRouteWithChildren
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAbsencesRoute: AdminAbsencesRoute,
  AdminAssignmentsRoute: AdminAssignmentsRouteWithChildren,
  AdminAuditRoute: AdminAuditRoute,
  AdminClientsRoute: AdminClientsRouteWithChildren,
  AdminComplianceRoute: AdminComplianceRoute,
  AdminDeadlinesRoute: AdminDeadlinesRoute,
  AdminPayrollExportRoute: AdminPayrollExportRoute,
  AdminSettingsRoute: AdminSettingsRoute,
  AdminSurchargeRuleSetsRoute: AdminSurchargeRuleSetsRoute,
  AdminTimesheetsRoute: AdminTimesheetsRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminWorkersRoute: AdminWorkersRouteWithChildren,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface ClientRouteChildren {
  ClientAssignmentsRoute: typeof ClientAssignmentsRoute
  ClientOnboardingRoute: typeof ClientOnboardingRoute
  ClientProfileRoute: typeof ClientProfileRoute
  ClientTimesheetsRoute: typeof ClientTimesheetsRoute
  ClientIndexRoute: typeof ClientIndexRoute
}

const ClientRouteChildren: ClientRouteChildren = {
  ClientAssignmentsRoute: ClientAssignmentsRoute,
  ClientOnboardingRoute: ClientOnboardingRoute,
  ClientProfileRoute: ClientProfileRoute,
  ClientTimesheetsRoute: ClientTimesheetsRoute,
  ClientIndexRoute: ClientIndexRoute,
}

const ClientRouteWithChildren =
  ClientRoute._addFileChildren(ClientRouteChildren)

interface WorkerRouteChildren {
  WorkerAbsencesRoute: typeof WorkerAbsencesRoute
  WorkerAssignmentsRoute: typeof WorkerAssignmentsRoute
  WorkerOnboardingRoute: typeof WorkerOnboardingRoute
  WorkerProfileRoute: typeof WorkerProfileRoute
  WorkerTimesheetsRoute: typeof WorkerTimesheetsRoute
  WorkerIndexRoute: typeof WorkerIndexRoute
}

const WorkerRouteChildren: WorkerRouteChildren = {
  WorkerAbsencesRoute: WorkerAbsencesRoute,
  WorkerAssignmentsRoute: WorkerAssignmentsRoute,
  WorkerOnboardingRoute: WorkerOnboardingRoute,
  WorkerProfileRoute: WorkerProfileRoute,
  WorkerTimesheetsRoute: WorkerTimesheetsRoute,
  WorkerIndexRoute: WorkerIndexRoute,
}

const WorkerRouteWithChildren =
  WorkerRoute._addFileChildren(WorkerRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  ClientRoute: ClientRouteWithChildren,
  ForbiddenRoute: ForbiddenRoute,
  PendingRoute: PendingRoute,
  WorkerRoute: WorkerRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
